import React from 'react';
import { useAppSelector } from 'hooks';
import { Alert } from 'reactstrap';

import { InputProps } from '~components/form-fields';
import Icon, { faInfoCircle } from '~components/icon';

import { selectClientByID } from '~main/selectors/clients/clients';
import { selectUserByID } from '~care-workers/selectors/users';

function FormInputWorkerRosterNotes({ value = {}, id }: InputProps) {
  const { user_id, client_id = '' } = value;
  const user = useAppSelector((state) => selectUserByID(state, parseInt(user_id)));
  const client = useAppSelector((state) => selectClientByID(state, parseInt(client_id)));

  const notes = user?.rostering_notes;

  const clientLangs: string[] = (client?.languages_spoken ?? []).filter(Boolean);
  const workerLangs: string[] = (user?.languages ?? []).filter(Boolean);
  const normalise = (s: string) => s.trim().toLowerCase();
  const clientLangsNorm = clientLangs.map(normalise);
  const hasLanguageMismatch =
    !!user_id && clientLangs.length > 0 && !workerLangs.some((lang) => clientLangsNorm.includes(normalise(lang)));

  const isOpen = !!(notes?.length || hasLanguageMismatch);

  if (!isOpen) return null;

  return (
    <Alert
      color="info"
      className="d-flex align-items-start"
      data-id={id}
      data-cy={`${id}-alert`}
    >
      <Icon className="me-2 mt-1 flex-shrink-0" size="2x" icon={faInfoCircle} />
      <div className="d-flex flex-column gap-1">
        {notes && <div className="fw-bold form-notes">{notes}</div>}
        {hasLanguageMismatch && <div className="fw-bold form-notes">{"Care worker does not speak the client's preferred language"}</div>}
      </div>
    </Alert>
  );
}

export default FormInputWorkerRosterNotes;
